module.exports = __webpack_public_path__ + "static/media/6.5f99bc6a.jpg";